import { render, staticRenderFns } from "./EditNotesModal.vue?vue&type=template&id=6558b4dd&"
import script from "./EditNotesModal.vue?vue&type=script&lang=js&"
export * from "./EditNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6558b4dd')) {
      api.createRecord('6558b4dd', component.options)
    } else {
      api.reload('6558b4dd', component.options)
    }
    module.hot.accept("./EditNotesModal.vue?vue&type=template&id=6558b4dd&", function () {
      api.rerender('6558b4dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/components/EditNotesModal.vue"
export default component.exports